



























import { Vue, Component } from "vue-property-decorator";
import SubscriptionBox from "@/modules/subscriptions/components/SubscriptionBox.vue";

import { namespace } from "vuex-class";
import { SubscriptionPlan } from "../types";
const Subscription = namespace("subscriptions");

@Component({
  components: { "subscription-box": SubscriptionBox },
})
export default class ChoosePlan extends Vue {
  @Subscription.Action("getAllSubscriptionPlans")
  getAllSubscriptionPlans!: () => Promise<{}>;
  @Subscription.Getter("allSubscriptionPlans")
  plans: SubscriptionPlan[];
  @Subscription.Getter("getCurrentSubscriptionPlan")
  currentPlan: SubscriptionPlan;

  async beforeMount() {
    await this.getAllSubscriptionPlans();
  }
  goBack() {
    this.$router.push({ name: "subscriptions" });
  }
  getVerificationPrice(subscriptionPlanName) {
    switch (subscriptionPlanName) {
      case "Startup":
        return "1.25";
      case "Growth":
        return "1.00";
      case "Scale":
        return "0.85";
    }
  }
  getSubscriptionCost(subscriptionCost) {
    switch (subscriptionCost) {
      case "Startup":
        return "99";
      case "Growth":
        return "199";
      case "Scale":
        return "599";
    }
  }
}
